var map = {
	"./animals_bear.png": 30812,
	"./animals_cat1.png": 94747,
	"./animals_cat2.png": 16416,
	"./animals_cat3.png": 94537,
	"./animals_chicken.png": 73357,
	"./animals_cow.png": 9477,
	"./animals_deer.png": 87370,
	"./animals_duck.png": 16413,
	"./animals_elephant.png": 17109,
	"./animals_fox.png": 55991,
	"./animals_frog.png": 21496,
	"./animals_giraffe.png": 972,
	"./animals_goat.png": 43203,
	"./animals_lion.png": 36624,
	"./animals_monkey.png": 54993,
	"./animals_mouse.png": 78829,
	"./animals_owl.png": 6562,
	"./animals_panda.png": 97316,
	"./animals_penguin.png": 512,
	"./animals_pig.png": 31088,
	"./animals_poodle.png": 16357,
	"./animals_rabbit.png": 32810,
	"./animals_redpanda.png": 7569,
	"./animals_sheep.png": 16473,
	"./animals_shibainu.png": 12931,
	"./animals_tiger.png": 77801,
	"./animals_wolf.png": 50398,
	"./awards/awards_chip1.png": 63691,
	"./awards/awards_chip2.png": 49872,
	"./awards/awards_chip3.png": 56121,
	"./awards/awards_chip4.png": 53702,
	"./awards/awards_decoration1.png": 53815,
	"./awards/awards_decoration2.png": 95708,
	"./awards/awards_decoration3.png": 78597,
	"./awards/awards_firstplace.png": 40185,
	"./awards/awards_medal.png": 58977,
	"./awards/awards_money1.png": 34651,
	"./awards/awards_money2.png": 72672,
	"./awards/awards_moneybag.png": 80860,
	"./awards/awards_secondplace.png": 27917,
	"./awards/awards_thirdplace.png": 50254,
	"./awards/awards_trophies.png": 54528,
	"./awards/awards_trophy1.png": 23639,
	"./awards/awards_trophy2.png": 99708,
	"./awards/awards_trophy3.png": 51973,
	"./chess/chess_checkersblue.png": 63796,
	"./chess/chess_checkersgreen.png": 77527,
	"./chess/chess_checkerspurple.png": 60446,
	"./chess/chess_checkersred.png": 38695,
	"./chess/chess_checkersyellow.png": 90672,
	"./chess/chess_chessblack1.png": 97476,
	"./chess/chess_chessblack2.png": 99103,
	"./chess/chess_chessblack3.png": 45302,
	"./chess/chess_chessblack4.png": 95273,
	"./chess/chess_chessblack5.png": 71072,
	"./chess/chess_chessblack6.png": 52283,
	"./chess/chess_chesswhite1.png": 69714,
	"./chess/chess_chesswhite2.png": 34857,
	"./chess/chess_chesswhite3.png": 80032,
	"./chess/chess_chesswhite4.png": 38687,
	"./chess/chess_chesswhite5.png": 60598,
	"./chess/chess_chesswhite6.png": 51277,
	"./chess/chess_chinesechessblack1.png": 86841,
	"./chess/chess_chinesechessblack2.png": 22306,
	"./chess/chess_chinesechessblack3.png": 59787,
	"./chess/chess_chinesechessblack4.png": 97524,
	"./chess/chess_chinesechessblack5.png": 35005,
	"./chess/chess_chinesechessblack6.png": 93766,
	"./chess/chess_chinesechessblack7.png": 32783,
	"./chess/chess_chinesechessred1.png": 75325,
	"./chess/chess_chinesechessred2.png": 94118,
	"./chess/chess_chinesechessred3.png": 75663,
	"./chess/chess_chinesechessred4.png": 90288,
	"./chess/chess_chinesechessred5.png": 96537,
	"./chess/chess_chinesechessred6.png": 13602,
	"./chess/chess_chinesechessred7.png": 4107,
	"./chess/chess_goblack.png": 15989,
	"./chess/chess_gowhite.png": 25503,
	"./chess/chess_japanchess01.png": 2845,
	"./chess/chess_japanchess02.png": 35430,
	"./chess/chess_japanchess03.png": 4175,
	"./chess/chess_japanchess04.png": 8304,
	"./chess/chess_japanchess05.png": 24057,
	"./chess/chess_japanchess06.png": 10050,
	"./chess/chess_japanchess07.png": 73707,
	"./chess/chess_japanchess08.png": 93404,
	"./chess/chess_japanchess09.png": 10917,
	"./chess/chess_japanchess10.png": 30911,
	"./chess/chess_japanchess11.png": 77110,
	"./chess/chess_japanchess12.png": 92525,
	"./chess/chess_japanchess13.png": 29284,
	"./chess/chess_japanchess14.png": 84091,
	"./chess/chess_japanchess15.png": 62546,
	"./drink/drink_bubbletea.png": 23802,
	"./drink/drink_coffee.png": 25500,
	"./drink/drink_cola.png": 39951,
	"./drink/drink_fanta.png": 94548,
	"./drink/drink_latte.png": 2524,
	"./drink/drink_pepsi.png": 40797,
	"./drink/drink_sprite.png": 84235,
	"./drink/drink_tea.png": 12180,
	"./face/mood_angry.png": 37491,
	"./face/mood_cold.png": 60056,
	"./face/mood_cry.png": 92160,
	"./face/mood_devil.png": 95058,
	"./face/mood_die.png": 37454,
	"./face/mood_doubt.png": 27138,
	"./face/mood_happy.png": 1798,
	"./face/mood_hot.png": 28985,
	"./face/mood_hurt.png": 51513,
	"./face/mood_lauth.png": 94434,
	"./face/mood_love.png": 44138,
	"./face/mood_rolleyes.png": 16173,
	"./face/mood_sad.png": 91336,
	"./face/mood_shock.png": 67270,
	"./face/mood_sick.png": 62268,
	"./face/mood_sleep.png": 51173,
	"./face/mood_smile.png": 80136,
	"./festival/festival_chinesenewyear1.png": 295,
	"./festival/festival_chinesenewyear2.png": 80236,
	"./festival/festival_christmas.png": 60984,
	"./festival/festival_dragonboatfestival.png": 27013,
	"./festival/festival_easter.png": 10092,
	"./festival/festival_gift.png": 5344,
	"./festival/festival_halloween.png": 75165,
	"./festival/festival_luckycat.png": 36962,
	"./fish/fish_bigclam.png": 33617,
	"./fish/fish_clownfish.png": 31737,
	"./fish/fish_crab.png": 57452,
	"./fish/fish_eel.png": 8330,
	"./fish/fish_goldfish.png": 18478,
	"./fish/fish_octopus.png": 99931,
	"./fish/fish_pufferfish.png": 28748,
	"./fish/fish_shrimp.png": 49915,
	"./fish/fish_snapper.png": 14765,
	"./fish/fish_squid.png": 27542,
	"./fish/fish_starfish.png": 24716,
	"./fish/fish_tropicalfish.png": 89064,
	"./fish/fish_yellowfish.png": 75060,
	"./food/food_cake.png": 45058,
	"./food/food_dounut.png": 18283,
	"./food/food_hamburger.png": 19569,
	"./food/food_icecream.png": 30831,
	"./food/food_pieceofcake.png": 40161,
	"./food/food_pizza.png": 94850,
	"./food/food_popcorn.png": 2911,
	"./food/food_roastchicken.png": 45698,
	"./food/food_steak.png": 74810,
	"./fruit/fruit_apple.png": 14214,
	"./fruit/fruit_banana.png": 76523,
	"./fruit/fruit_cantaloupe.png": 51312,
	"./fruit/fruit_cherry.png": 12619,
	"./fruit/fruit_grape.png": 36067,
	"./fruit/fruit_grapefruit.png": 94525,
	"./fruit/fruit_kiwi.png": 95608,
	"./fruit/fruit_lemon.png": 16523,
	"./fruit/fruit_lyme.png": 93775,
	"./fruit/fruit_mulberry.png": 44698,
	"./fruit/fruit_orange.png": 48522,
	"./fruit/fruit_pinapple.png": 65023,
	"./fruit/fruit_snakeberry.png": 81764,
	"./fruit/fruit_strawberry.png": 45215,
	"./fruit/fruit_watermelon.png": 47382,
	"./gesture_five.png": 30976,
	"./gesture_good.png": 4759,
	"./gesture_ok.png": 58373,
	"./gesture_one.png": 34002,
	"./gesture_yeah.png": 79681,
	"./gesture_zero.png": 37686,
	"./manda/manda_001.png": 60783,
	"./manda/manda_002.png": 55668,
	"./manda/manda_003.png": 76797,
	"./manda/manda_004.png": 15074,
	"./manda/manda_005.png": 5579,
	"./manda/manda_006.png": 91760,
	"./manda/manda_007.png": 98009,
	"./manda/manda_008.png": 8622,
	"./manda/manda_009.png": 8119,
	"./manda/manda_010.png": 4353,
	"./manda/manda_011.png": 31640,
	"./manda/manda_012.png": 6131,
	"./manda/manda_013.png": 55370,
	"./manda/manda_014.png": 40037,
	"./manda/manda_015.png": 22524,
	"./manda/manda_016.png": 11255,
	"./manda/manda_017.png": 21262,
	"./manda/manda_018.png": 53177,
	"./manda/manda_019.png": 37424,
	"./manda/manda_020.png": 9196,
	"./manda/manda_021.png": 20821,
	"./manda/manda_022.png": 446,
	"./manda/manda_023.png": 76231,
	"./manda/manda_024.png": 96616,
	"./manda/manda_025.png": 28657,
	"./manda/manda_026.png": 68762,
	"./manda/manda_027.png": 58595,
	"./manda/manda_028.png": 58404,
	"./manda/manda_029.png": 21645,
	"./manda/manda_030.png": 22167,
	"./manda/manda_031.png": 92942,
	"./manda/manda_032.png": 63301,
	"./manda/manda_033.png": 80412,
	"./manda/manda_034.png": 35283,
	"./manda/manda_035.png": 80074,
	"./manda/manda_036.png": 10657,
	"./manda/manda_037.png": 89528,
	"./manda/manda_038.png": 14479,
	"./manda/manda_039.png": 75462,
	"./manda/manda_040.png": 70410,
	"./manda/manda_041.png": 25619,
	"./music/music_001.png": 70703,
	"./music/music_002.png": 96212,
	"./music/music_003.png": 29245,
	"./music/music_004.png": 24994,
	"./music/music_005.png": 46123,
	"./music/music_006.png": 74832,
	"./music/music_007.png": 81081,
	"./music/music_008.png": 49166,
	"./music/music_009.png": 94743,
	"./music/music_010.png": 33505,
	"./music/music_011.png": 48888,
	"./music/music_012.png": 39731,
	"./music/music_013.png": 84522,
	"./music/music_014.png": 69189,
	"./music/music_015.png": 39772,
	"./music/music_016.png": 40407,
	"./music/music_017.png": 97390,
	"./music/music_018.png": 70425,
	"./music/music_019.png": 89872,
	"./music/music_020.png": 68972,
	"./music/music_021.png": 54421,
	"./music/music_022.png": 87070,
	"./music/music_023.png": 5383,
	"./music/music_024.png": 13864,
	"./music/music_025.png": 28081,
	"./music/music_026.png": 97914,
	"./music/music_027.png": 99139,
	"./other_bell.png": 44002,
	"./other_book.png": 23002,
	"./other_books.png": 21179,
	"./other_clock.png": 7131,
	"./other_doll.png": 69434,
	"./other_earth.png": 52765,
	"./other_goal.png": 14584,
	"./other_hourglass.png": 67131,
	"./other_light.png": 67325,
	"./other_teddy.png": 94451,
	"./people/img_student1.png": 59900,
	"./people/img_student2.png": 48631,
	"./people/img_student3.png": 74990,
	"./people/img_student4.png": 58081,
	"./people/img_student5.png": 69016,
	"./people/img_student6.png": 59859,
	"./people/img_teacher1.png": 70153,
	"./people/img_teacher2.png": 21362,
	"./people/img_teacher3.png": 70363,
	"./people/img_teacher4.png": 60420,
	"./people/img_teacher5.png": 2925,
	"./sports/sport_americanfootball.png": 83254,
	"./sports/sport_archery.png": 1637,
	"./sports/sport_badminton.png": 57305,
	"./sports/sport_baseball.png": 74631,
	"./sports/sport_basketball.png": 91034,
	"./sports/sport_soccer.png": 17734,
	"./sports/sport_tabletennis.png": 57514,
	"./sports/sport_tennis.png": 56086,
	"./sports/sport_volleyball.png": 98271,
	"./symbol/symbol_arrow1black.png": 56505,
	"./symbol/symbol_arrow1blue.png": 11074,
	"./symbol/symbol_arrow1green.png": 66833,
	"./symbol/symbol_arrow1red.png": 81729,
	"./symbol/symbol_arrow1yellow.png": 92658,
	"./symbol/symbol_arrow2black.png": 19988,
	"./symbol/symbol_arrow2blue.png": 50093,
	"./symbol/symbol_arrow2green.png": 18516,
	"./symbol/symbol_arrow2red.png": 75024,
	"./symbol/symbol_arrow2yellow.png": 96749,
	"./symbol/symbol_correct.png": 78642,
	"./symbol/symbol_deleteblack.png": 33174,
	"./symbol/symbol_deleteblue.png": 16811,
	"./symbol/symbol_deletegreen.png": 99094,
	"./symbol/symbol_deletered.png": 12986,
	"./symbol/symbol_deleteyellow.png": 95399,
	"./symbol/symbol_good.png": 18505,
	"./symbol/symbol_hashblack.png": 75889,
	"./symbol/symbol_hashblue.png": 17242,
	"./symbol/symbol_hashgreen.png": 14841,
	"./symbol/symbol_hashred.png": 63097,
	"./symbol/symbol_hashyellow.png": 6970,
	"./symbol/symbol_heart.png": 53020,
	"./symbol/symbol_marine.png": 86360,
	"./symbol/symbol_questionblack.png": 76389,
	"./symbol/symbol_questionblue.png": 30038,
	"./symbol/symbol_questiongreen.png": 29989,
	"./symbol/symbol_questionred.png": 91765,
	"./symbol/symbol_questionyellow.png": 1622,
	"./symbol/symbol_starblack.png": 62349,
	"./symbol/symbol_starblue.png": 44286,
	"./symbol/symbol_stargreen.png": 98845,
	"./symbol/symbol_starred.png": 93853,
	"./symbol/symbol_staryellow.png": 85358,
	"./traffic_ballon.png": 60558,
	"./traffic_car.png": 43370,
	"./traffic_scooter.png": 90125,
	"./traffic_truck.png": 26129,
	"./veg_bellpepper.png": 87294,
	"./veg_carrot.png": 18336,
	"./veg_mushroom.png": 70167,
	"./weather/weather_.png": 34932,
	"./weather/weather_cloud.png": 12881,
	"./weather/weather_moon.png": 54211,
	"./weather/weather_rainbow.png": 36424,
	"./weather/weather_snow.png": 55093,
	"./weather/weather_star.png": 53416,
	"./weather/weather_sun.png": 86280,
	"./weather/weather_thunder.png": 2848,
	"./weather/weather_tornado.png": 45141,
	"./weather/weather_umberlla.png": 54246,
	"./weather/weather_windy.png": 78549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57726;